import { FC, SVGProps } from 'react';

export const ArrowRightIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
		<g clipPath="url(#clip0_5999_14394)">
			<path d="M-0.25 15.5L9 6L-0.25 -3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		</g>
		<defs>
			<clipPath id="clip0_5999_14394">
				<rect width="12" height="12" fill="white" transform="matrix(-1 0 0 -1 12 12)" />
			</clipPath>
		</defs>
	</svg>
);
